
(function () {
  if (customElements.get('accordion-group')) return;

  function debounce(fn, wait) {
    let timer;
    return function debounced() {
      clearTimeout(timer);
      timer = setTimeout(() => fn(), wait);
    };
  }

  class AccordionGroup extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-accordion-content]'));
      if (!this.items.length) return;

      this._cleanups = [];
      this.activeContent = null;
      this.activeIcon = null;

      // Open the first panel by default.
      const firstContent = this.items[0];
      const firstButton = firstContent.previousElementSibling;
      const firstIcon = firstButton?.querySelector('[data-accordion-icon]');
      firstButton?.setAttribute('aria-expanded', 'true');
      firstIcon?.classList.add('t-rotate-180');
      firstContent.style.maxHeight = `${firstContent.scrollHeight}px`;
      this.activeContent = firstContent;
      this.activeIcon = firstIcon;

      this.querySelectorAll('button').forEach((button) => {
        const handler = () => this.toggle(button);
        button.addEventListener('click', handler);
        this._cleanups.push(() => button.removeEventListener('click', handler));
      });

      // Keep the open panel's pixel height correct when the layout reflows.
      this._onResize = debounce(() => {
        if (this.activeContent) {
          this.activeContent.style.maxHeight = `${this.activeContent.scrollHeight}px`;
        }
      }, 150);
      window.addEventListener('resize', this._onResize, { passive: true });
    }

    disconnectedCallback() {
      this._cleanups?.forEach((off) => off());
      this._cleanups = [];
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      this._onResize = null;
    }

    toggle(button) {
      const content = button.nextElementSibling;
      const icon = button.querySelector('[data-accordion-icon]');
      const isExpanded = button.getAttribute('aria-expanded') === 'true';

      if (isExpanded) {
        // Closing the open panel → reopen the first.
        this.close(this.activeContent, this.activeIcon);
        const firstContent = this.items[0];
        const firstButton = firstContent.previousElementSibling;
        this.open(firstContent, firstButton, firstButton?.querySelector('[data-accordion-icon]'));
      } else {
        if (this.activeContent && this.activeContent !== content) {
          this.close(this.activeContent, this.activeIcon);
        }
        this.open(content, button, icon);
      }
    }

    open(content, button, icon) {
      if (!content) return;
      button?.setAttribute('aria-expanded', 'true');
      content.style.maxHeight = `${content.scrollHeight}px`;
      icon?.classList.add('t-rotate-180');
      this.activeContent = content;
      this.activeIcon = icon;
    }

    close(content, icon) {
      if (content) {
        content.style.maxHeight = '0';
        content.previousElementSibling?.setAttribute('aria-expanded', 'false');
      }
      icon?.classList.remove('t-rotate-180');
    }
  }

  customElements.define('accordion-group', AccordionGroup);
})();
